<template>
	<div class="col-12 pl-0 pr-0">
		<GChart
		type="PieChart"
		:data="chartData"
		:options="chartOptions"
		:resizeDebounce="500"
		/>
		<div class="col-3 font-size-14 total">
			<div class="col-12 font-weight-bold">Total</div>
			<div class="col-12">156</div>
		</div>
	</div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
	components: {
		GChart
	},
	name: 'IChart',
	data() {
		return {
			chartData: [
			['Status', 'Qty'],
			['Registered', 111],
			['Waiting', 12],
			['Pending', 32],
			],
			chartOptions: {
				legend: {
					position: 'bottom',
				},
				tooltip: {
					ignoreBounds: true,
					text: 'value',
				},
				chartArea:{
					left:30,
					top:30,
					width:'100%'
					,height:'75%'
				},
				pieHole: 0.8,
				fontName: 'Poppins',
				fontSize: 12,
				width: '100%',
				height: 300,
				pieSliceText: 'none',
				colors: ['#4dc3d2', '#e92124', '#9D9B9C']
			},
		}
	}
};
</script>

<style>
.total {
	position: absolute;
	z-index: 2;
	text-align: center;
	top: 40%;
	left: 40%;
	transition: .5s ease;
}
.total:hover {
	font-size: 16pt;
	transition: .5s ease;
}
</style>